/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { classes as cn, formatAmount } from '../utils';

const defaultMaskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 12, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
};

interface Props {
  label?: string,
  placeholder?: string,
  value?: string | number,
  onValueChange?: (value: string | number) => void,
  className?: string,
}

const CurrencyInput = ({ label, placeholder, value, onValueChange, className, ...inputProps }: Props) => {
  const currencyMask = createNumberMask(defaultMaskOptions);
  const [innerValue, setInnerValue] = useState(value);

  const onChange = (newValue: string) => {
    const amount = newValue === "" ? "" : String(newValue).replace(/\./g, '').replace(',', '.');
    if (onValueChange) onValueChange(amount);
    setInnerValue(newValue);
  };

  useEffect(() => {
    if (value && Number(value) > 0) {
      setInnerValue(formatAmount(value));
    }
  }, []);

  return (
    <div className={cn('form-group form-group-input', className)}>
      { label && <label>{ label }</label> }
        <MaskedInput
          value={innerValue}
          placeholder={placeholder}
          {...inputProps}
          className="form-control input-white"
          onChange={(e) => onChange(e.target.value)}
          inputMode="numeric"
          mask={currencyMask}
        />
    </div>
  );
};

export default CurrencyInput;